import { APIRequest } from '@reverbdotcom/discovery-ui';

class InferCategoryQuery {
  constructor(make, model) {
    this.make = make.trim();
    this.model = model.trim();
  }

  sameAs(query) {
    return query.make === this.make && query.model === this.model;
  }

  get hasAllParts() {
    return this.make.length !== 0 && this.model.length !== 0;
  }

  fetch() {
    return APIRequest.get(
      '/listings/infer_category_id',
      { make: this.make, model: this.model },
    );
  }
}

export default InferCategoryQuery;
